import lang from '../languages/de.json'

const translate = ( text, label, label2, label3, label4, label5 ) => {

  if( 'en' === process.env.GATSBY_SITE_LANG ) {

    return text

  }
  

  if( label !== undefined ) {

    let sentence = text.replace( label, '{}')

    if( label2 !== undefined ) {

      sentence = sentence.replace( label2, '{{}}' )
    
    }

    if( label3 !== undefined ) {

      sentence = sentence.replace( label3, '{{3}}' )
    
    }

    if( label4 !== undefined ) {

      sentence = sentence.replace( label4, '{{4}}' )
    
    }

    if( label5 !== undefined ) {

      sentence = sentence.replace( label5, '{{5}}' )
    
    }

    let res = lang[ sentence ]

    if( res !== undefined ) {
      res = res.replace( '{}', label )
      if( label2 !== undefined ){
        res = res.replace( '{{}}', label2 )
      }
      if( label3 !== undefined ){
        res = res.replace( '{{3}}', label3 )
      }
      if( label4 !== undefined ){
        res = res.replace( '{{4}}', label4 )
      }
      if( label5 !== undefined ){
        res = res.replace( '{{5}}', label5 )
      }
      return res 
    }
   
  }

  return lang[ text ] || text

}

export default translate